export const emptyDefinition = '{"kind":"program"}';

/**
 * Checks if a given definition can be used to display a props table.
 *
 * It will reject invalid results, but does not perform full validation.
 * This should be fine for our use case of checking if an auto generated page
 * has prop information.
 */
const isValidPropsDefinition = (definition?: unknown): boolean => {
	if (typeof definition !== 'string') {
		return false;
	}

	/**
	 * Pages that don't have auto generated prop info will still have a value
	 * for workspace.definition of `"{\"kind\":\"program\"}"`.
	 *
	 * This uses a very cheap check of string length instead of parsing the
	 * full JSON object.
	 */
	return definition.length > emptyDefinition.length;
};

export default isValidPropsDefinition;
